const PATTERNS = { '#': /^#[\p{L}\p{N}_]+$/u, '@': /^@[\p{L}\p{N}_.-]+$/u };

/** Bounded, deduplicated campaign tags of one kind; anything else is dropped, never rendered. */
export function safeCaptionTokens(value: unknown, marker: '#' | '@'): string[] {
  if (!Array.isArray(value)) return [];
  const tokens = value.filter((token): token is string => typeof token === 'string'
    && token.length <= 100 && PATTERNS[marker].test(token));
  return [...new Set(tokens)].slice(0, 50);
}
